import {
  unredeemedpawn_overall_v4,
  unredeemedpawn_cluster_v4,
  unredeemedpawn_area_v4,
  unredeemedpawn_branch_v4,
} from "../../v4-services/reports/unredeemedpawn_service";
import { actionTypes } from "../action_types";

const defaultUnredeemedPawn = {
  newPawnSummaries: {
    totalPieces: 0,
    totalPrincipal: 0,
  },
  pastDueSummaries: {
    totalPieces: 0,
    totalPrincipal: 0,
  },
  overDueSummaries: {
    totalPieces: 0,
    totalPrincipal: 0,
  },
  longOverDueSummaries: {
    totalPieces: 0,
    totalPrincipal: 0,
  },
};

const createUnredeemedPawnAction =
  (fetchFunction, actionType) => (data) => (dispatch) => {
    return fetchFunction(data).then((resp) => {
      if (resp.problem === null) {
        dispatch({
          type: actionType,
          payload: resp.data !== null ? resp.data : defaultUnredeemedPawn,
        });
      }
      return Promise.resolve(resp);
    });
  };

export const GetUnredeemedPawnOverallV4 = createUnredeemedPawnAction(
  unredeemedpawn_overall_v4,
  actionTypes.REPORTS_UNREDEEMEDPAWNS_GET_OVERALL
);

export const GetUnredeemedPawnClusterV4 = createUnredeemedPawnAction(
  unredeemedpawn_cluster_v4,
  actionTypes.REPORTS_UNREDEEMEDPAWNS_GET_CLUSTER
);

export const GetUnredeemedPawnAreaV4 = createUnredeemedPawnAction(
  unredeemedpawn_area_v4,
  actionTypes.REPORTS_UNREDEEMEDPAWNS_GET_AREA
);

export const GetUnredeemedPawnBranchV4 = createUnredeemedPawnAction(
  unredeemedpawn_branch_v4,
  actionTypes.REPORTS_UNREDEEMEDPAWNS_GET_BRANCH
);
